import { useEffect, useState } from 'react';
import api from './api';
import sources from './sources';
import useGym from './use_gym';
import { MobileAppSettings } from 'react/types/mobile_app_settings';

const useMobileAppSettings = (): MobileAppSettings => {
  const gym = useGym();
  const [mobileAppSettings, setMobileAppSettings] = useState<MobileAppSettings>(null);

  useEffect(() => {
    api.get(sources.mobileAppSettings(gym.id)).then((data) => {
      setMobileAppSettings(data[0]);
    });
  }, [gym.id]);

  return mobileAppSettings;
};

export default useMobileAppSettings;
